import { CredentialsValidationRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class CredentialsValidationService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new CredentialsValidationRouteService());
	}

	validateChannel = async resource => {
		var url = this.routeService.validateChannel(resource);
		return this.apiClient.post(url, resource);
	};

	validateCarrier = async resource => {
		var url = this.routeService.validateCarrier(resource);
		return this.apiClient.post(url, resource);
	};
}

export default CredentialsValidationService;



// WEBPACK FOOTER //
// ./src/common/data/services/CredentialsValidationService.js